import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getApiClient } from "../api-client";
import type {
  Facilitator,
  InviteFacilitatorInput,
  RevokeFacilitatorInput,
} from "./facilitator-types";

const LIST_KEY = ["staff", "facilitators"] as const;

export function useFacilitatorsQuery() {
  return useQuery<Facilitator[]>({
    queryKey: LIST_KEY,
    queryFn: () =>
      getApiClient().get<Facilitator[]>("/admin/plotlounge/facilitators"),
    staleTime: 30 * 1000,
  });
}

export function useInviteFacilitatorMutation() {
  const qc = useQueryClient();
  return useMutation<Facilitator, Error, InviteFacilitatorInput>({
    mutationFn: (input) =>
      getApiClient().post<Facilitator>("/admin/plotlounge/facilitators", input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: LIST_KEY });
    },
  });
}

export function useRevokeFacilitatorMutation() {
  const qc = useQueryClient();
  return useMutation<
    Facilitator,
    Error,
    { userId: string; input: RevokeFacilitatorInput }
  >({
    mutationFn: ({ userId, input }) =>
      getApiClient().post<Facilitator>(
        `/admin/plotlounge/facilitators/${userId}/revoke`,
        input,
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: LIST_KEY });
    },
  });
}
